import {Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {ActivationEtaItem} from './ActivationEtaItem';
import {ActivationProgressBar} from './ActivationProgressBar';

import type {ProgressPackage} from './ActivationProgressBar';
import type {FC} from 'react';

export interface ActivationPageHeaderProps {
  /** Shows the submission progress bar under the title when provided. */
  packages?: ProgressPackage[];
}

export const ActivationPageHeader: FC<ActivationPageHeaderProps> = ({packages}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <div data-slot="activation-page-header">
      <div className="flex items-start justify-between gap-4 px-7 py-6">
        <div className="flex flex-col items-start gap-1.5 text-start">
          <Typography as="h2" size="display-2xs" weight="semibold" className="whitespace-normal">
            {t('activation.sectionTitle')}
          </Typography>

          <Typography as="p" size="sm" color="secondary" className="truncate">
            {t('activation.sectionSubtitle')}
          </Typography>
        </div>

        <ActivationEtaItem />
      </div>
      {packages && <ActivationProgressBar packages={packages} className="px-7 pb-6" />}
      <hr className="border-border-subtle" />
    </div>
  );
};
